import React, { ReactElement } from 'react';
import { ReadinessStatus } from '../../../types';

export interface ReadinessTagProps {
  tag?: ReadinessStatus;
  invertColors?: boolean;
}

const ReadinessTag = ({
  tag,
  invertColors = false,
}: ReadinessTagProps): ReactElement | null => {
  if (!tag) return null;
  if (tag == ReadinessStatus.GA) return null;

  return (
    <div className={`rounded-md ${invertColors ? 'bg-gray-100 text-gray-700' : 'bg-gray-500 text-white'} flex items-center justify-center px-2 font-bold text-s`}>
      {tag}
    </div>
  );
};

export default ReadinessTag;
